import { z } from 'zod';
const checkOutVolunteerParamsSchema = z.object({
    participationId: z.string().uuid(),
});
const checkOutVolunteerResponseSchema = z.object({
    id: z.string().uuid(),
});
export const checkOutVolunteerFunctionDef = {
    name: 'checkOutVolunteer',
    requestSchema: checkOutVolunteerParamsSchema,
    responseSchema: checkOutVolunteerResponseSchema.optional(),
};
